import React, { useEffect, useState } from 'react';
import * as service from '@services/api/member-pharmacy-service';
import { useLocation, useNavigate } from 'react-router';
import { useGlobalStore } from '@services/store/global-store';
import {
  Alert,
  AlertDescription,
  Button,
  DatePicker,
  RadioGroup
} from '@see-ui/core';

const ScheduleRefill: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cart = location.state?.cart || [];
  const { memberDetails } = useGlobalStore((state) => state);
  const [questionnaireData, setQuestionnaireData] = useState<any>([]);
  const [answers, setAnswers] = useState<{ [questionId: number]: any }>({});
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const getSpecialtyQuestionnaire = async () => {
    let rxIds = cart.map((item: any) => item.rxNumber);
    const request = {
      hcid: memberDetails?.member?.memberPolicy?.hcid,
      refillRxIds: rxIds
    };
    const response = await service.getSpecialtyQuestionnaire(request);
    setQuestionnaireData(response?.data);
  };
  useEffect(() => {
    getSpecialtyQuestionnaire();
  }, []);

  const handleChange = (questionId: number, value: any) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: String(value)
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitSuccess(false);

    const filteredQuestions = questionnaireData?.filter(
      (q: any) => q.answerType !== 'information'
    );

    for (const q of filteredQuestions) {
      const answer = answers[q.id] || '';
      let answerResponseId = '';
      let answerValue = '';

      if (q.answerType === 'radio' || q.answerType === 'date') {
        const selected = (q.answerSuggestions || []).find((opt: any) =>
          q.answerType === 'date'
            ? String(opt.value) === String(answer)
            : String(opt.id) === String(answer)
        );
        answerResponseId = selected ? String(selected.id) : '';
        answerValue = selected ? selected.value : '';
      } else {
        answerValue = answer;
      }

      const req = {
        userId: '452',
        parentId: 0,
        assessmentExecId: q.executionId,
        containerId: q.containerId,
        contractId: String(q.contractId),
        contextId: '0',
        contextType: '',
        questionId: q.id,
        answerResponseId,
        answerValue
      };

      const requestToapi = {
        answerResponse: req
      };

      try {
        await service.submitQuestionnaireAnswerResponse(requestToapi);
        // console.log('Submitted answer for question', q.id, req);
      } catch (err) {
        console.error('Error submitting answer for question', q.id, err);
      }
      setSubmitSuccess(true);
    }
  };
  return (
    <div className="p-4">
      {submitSuccess && (
        <Alert variant="success">
          <React.Fragment key=".0">
            <AlertDescription>
              Your refill request has been submitted successfully! We are
              working on your order, and will reach out if there are any issues.
              Return to pharmacy{' '}
              <a href="/member-page/pharmacy" className="underline">
                Pharmacy Dashboard
              </a>
              .
            </AlertDescription>
          </React.Fragment>
        </Alert>
      )}

      <h2 className="text-2xl font-bold mb-4">Specialty Drug Questionnaire</h2>
      <form className="space-y-6" onSubmit={handleSubmit}>
        {questionnaireData?.map((q, idx) => (
          <div key={q.id} className="bg-white rounded shadow p-4">
            {q.answerType === 'information' ? (
              <div className="bg-blue-50 border-l-4 border-blue-400 p-3 text-blue-900">
                <span className="font-semibold">Note:</span> {q.label}
              </div>
            ) : (
              <>
                <label className="block font-semibold mb-2">
                  {q.label}
                  {q.repeatForPrescription && (
                    <span className="ml-2 text-xs text-gray-500">
                      (For each prescription)
                    </span>
                  )}
                </label>
                {q.answerType === 'text' && (
                  <input
                    type="text"
                    className="border rounded px-3 py-2 w-full"
                    placeholder="Enter your answer"
                    value={answers[q.id] || ''}
                    onChange={(e) => handleChange(q.id, e.target.value)}
                  />
                )}
                {q.answerType === 'email' && (
                  <input
                    type="email"
                    className="border rounded px-3 py-2 w-full"
                    placeholder="Enter your email"
                    value={answers[q.id] || ''}
                    onChange={(e) => handleChange(q.id, e.target.value)}
                  />
                )}
                {/* {q.answerType === 'date' && (
                  <DatePicker
                    color="info"
                    format="MM/dd/yyyy"
                    placeholder="Select a date"
                    size="md"
                  />
                )} */}
                {q.answerType === 'date' && q.answerSuggestions && (
                  <select
                    className="border rounded px-3 py-2 w-full"
                    value={answers[q.id] || ''}
                    onChange={(e) => handleChange(q.id, String(e.target.value))}
                  >
                    {' '}
                    <option value="">Select a date</option>
                    {q.answerSuggestions.map((opt: any) => (
                      <option key={opt.id} value={opt.value}>
                        {opt.value}
                      </option>
                    ))}
                  </select>
                )}
                {q.answerType === 'radio' && (
                  <RadioGroup
                    name={`question-${q.id}`}
                    layout="column"
                    options={q.answerSuggestions.map((opt: any) => ({
                      label: opt.value,
                      value: String(opt.id)
                    }))}
                    value={answers[q.id] || ''}
                    onValueChange={(value) => handleChange(q.id, value)}
                  />
                )}
              </>
            )}
          </div>
        ))}
        <div className="flex justify-end">
          <Button
            type="button"
            variant="secondary"
            className="mr-2"
            onClick={() => navigate(-1)}
          >
            Cancel order
          </Button>
          <Button type="submit">Schedule Refill</Button>
        </div>
      </form>
    </div>
  );
};
export default ScheduleRefill;
